import type { Project, Session } from "@mux/sdk/v2/client"
import { isWorkspaceOraclePath } from "@/utils/navigation"

export const cmp = (a: string, b: string) => (a < b ? -1 : a > b ? 1 : 0)

export const sortSessionsByID = (sessions: readonly Session[]) =>
  [...sessions].sort((a, b) => cmp(a.id, b.id))

export function sanitizeProject(project: Project) {
  if (!project.icon?.url && !project.icon?.override) return project
  return {
    ...project,
    icon: {
      ...project.icon,
      url: undefined,
      override: undefined,
    },
  }
}

export function getActiveSessionIds(
  pathname = "",
  _search = "",
  extra: Iterable<string> = [],
  sessions: readonly (Session & { isWorkspaceOracle?: boolean })[] = [],
) {
  const ids = new Set<string>()
  const segments = pathname.split("/").filter(Boolean)
  const sessionIndex = segments.indexOf("session")
  const routeID = sessionIndex >= 0 ? segments[sessionIndex + 1] : undefined
  if (routeID && !routeID.includes(".")) ids.add(routeID)
  // Oracle routes name the workspace, not the hidden session ID.
  for (const session of sessions) {
    if (session.isWorkspaceOracle && isWorkspaceOraclePath(pathname, session.workspaceID)) ids.add(session.id)
  }
  for (const id of extra) {
    if (id) ids.add(id)
  }
  return ids
}

/** Visible sessions (routed, a hidden workspace Oracle, or extra mounted surfaces such as Grid tiles) whose transcripts must recover after reconnect. */
export function activeSessionTargets(
  pathname: string,
  search: string,
  sessions: readonly (Session & { isWorkspaceOracle?: boolean })[],
  extra: Iterable<string> = [],
) {
  return [...getActiveSessionIds(pathname, search, extra, sessions)].flatMap((sessionID) => {
    const info = sessions.find((item) => item.id === sessionID)
    const directory = info?.workspaceID || info?.directory
    return directory ? [{ directory, sessionID }] : []
  })
}
